export default "__VITE_ASSET__BqRCQ22w__"